import FeedbackRepositoryInterface, {
  FeedbackDataInterface,
  FeedbackInterface, FeedbackResponseInterface, FeedbackStatus,
} from '@/services/QA/feedback/interfaces';
import { AxiosInstance } from 'axios';

export default class FeedbackRepository implements FeedbackRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async createChatFeedback(chatId: string, data: FeedbackDataInterface): Promise<void> {
    await this.axios.post(`/qa-controller/feedback/chat/${chatId}`, data);
  }

  public async createTicketFeedback(ticketId: number, data: FeedbackDataInterface): Promise<void> {
    await this.axios.post(`/qa-controller/feedback/ticket/${ticketId}`, data);
  }

  public async getAllFeedbacks(
    currentPage: number,
    sortBy: string,
    sortDesc: boolean,
  ): Promise<[FeedbackInterface[], number]> {
    const direction = sortDesc ? 'DESC' : 'ASC';
    const baseUrl = '/qa-controller/feedback';
    const urlParams = `?page=${currentPage}&sortBy=${sortBy}&direction=${direction}`;
    const res = await this.axios.get(`${baseUrl}${urlParams}`);

    return res.data;
  }

  public async searchFeedbacks(
    currentPage: number,
    search: string,
    sortBy: string,
    sortDesc: boolean,
  ): Promise<[FeedbackInterface[], number]> {
    const direction = sortDesc ? 'DESC' : 'ASC';
    const baseUrl = `/qa-controller/feedback/search/${encodeURIComponent(search)}`;
    const urlParams = `?page=${currentPage}&sortBy=${sortBy}&direction=${direction}`;
    const res = await this.axios.get(`${baseUrl}${urlParams}`);

    return res.data;
  }

  public async getOneById(id: number): Promise<FeedbackResponseInterface> {
    const res = await this.axios.get(`/qa-controller/feedback/${id}`);

    return res.data;
  }

  public async changeFeedbackStatus(id: number, status: FeedbackStatus): Promise<void> {
    await this.axios.patch(`/qa-controller/feedback/${id}`, { status });
  }

  public async getUserFeedbacks(userId: string): Promise<FeedbackInterface[]> {
    const res = await this.axios.get(`/qa-controller/feedback/user/${userId}`);

    return res.data;
  }
}
